export default {"src":"/_next/static/media/expo-icon.74f91fe9.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};